import Link from 'next/link';
import { useEffect } from 'react';
import { addNextjsError } from '@datadog/browser-rum-nextjs';
import { isDatadogEnabled } from '@/lib/datadog/config';

/**
 * The default error screen meant to be used on error.js files across the app.
 * Note that error.js *must* be a client component according to nextjs docs.
 */
export default function ErrorScreen({ error }) {
  useEffect(() => {
    if (!isDatadogEnabled) return;

    // Reports to datadog with `error.digest` attached
    addNextjsError(error);
  }, [error]);

  return (
    <div className="relative h-150">
      <div className="absolute top-1/2 left-1/2 w-full -translate-x-1/2 -translate-y-1/2 justify-center text-center">
        <div className="h3 sm:h2 lg:h1 text-parlor-green pb-4">
          An error occurred
        </div>
        <div className="body-l pb-4">
          Sorry about that! Please ensure that cookies and JavaScript are
          enabled, then return to our homepage.
        </div>
        <Link href={'/'} prefetch={false} className="txt-btn-secondary body-l">
          Go to the Leesa homepage
        </Link>
      </div>
    </div>
  );
}
